import {
  type ComponentStyleConfig,
  theme as originalTheme,
} from '@chakra-ui/theme';

const originalStyleConfig = originalTheme.components.Textarea;
const originalBaseStyleConfig = originalStyleConfig.baseStyle;
export const Textarea: ComponentStyleConfig = {
  baseStyle: {
    _placeholder: {
      color: 'grey.400',
    },
    _invalid: {
      borderColor: 'red.500',
      _hover: {
        borderColor: 'red.500',
      },
      _focusVisible: {
        borderColor: 'blue.500',
      },
    },
    _disabled: {
      borderColor: 'grey.300',
      bg: 'grey.50',
      color: 'grey.300',
      _hover: {
        borderColor: 'grey.300',
      },
    },
  },
  variants: {
    'republic-default': {
      ...originalBaseStyleConfig,
      ...originalStyleConfig.variants?.outline,
    },
    'republic-lite': {
      ...originalBaseStyleConfig,
      border: '1px solid',
      borderColor: 'grey.400',
      borderRadius: 'base',
      _placeholder: {
        color: 'grey.200',
        fontSize: 'md',
        lineHeight: 'base',
        fontWeight: 'normal',
        letterSpacing: 'less-tight',
      },
      color: 'grey.900',
      fontSize: 'md',
      lineHeight: 'base',
      fontWeight: 'normal',
      letterSpacing: 'less-tight',
      position: 'relative',
    },
  },
  sizes: {
    'republic-default': {
      ...originalStyleConfig.sizes?.md,
    },
  },
};
